<template>
  <v-layout row wrap mt-2 mb-2>
    <v-flex class="textos-marco" pa-3 aligner>
      <p>{{texto}}</p>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props:{
    texto: {
      type: String,
      required: true
    }
  }
}
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Textomarco.vue?0ec7a4eb